<template>
  <div class="relative w-full h-full overflow-y-auto p-4">
    <div class="bg-white rounded-lg p-6 mb-4 max-w-2xl">
      <h2 class="font-bold text-xl mb-4">Wartungsmodus</h2>
      <div v-if="loading" class="text-gray-500">Lade Status...</div>
      <div v-if="!loading">
        <div class="mb-4 p-4 rounded" :class="status.active ? 'bg-red-100' : 'bg-green-100'">
          <p v-if="status.active" class="text-red-700">
            <strong>Wartungsmodus ist aktiv.</strong>
            <span v-if="status.until"> Bis: {{ status.until }}</span>
          </p>
          <p v-else class="text-green-700">
            <strong>Wartungsmodus ist nicht aktiv.</strong>
          </p>
        </div>
        <p class="text-gray-600 mb-4">
          Im Wartungsmodus wird Kunden eine Wartungsseite angezeigt. Sie können sich nicht einloggen und keine Buchungen durchführen.
        </p>
        <div v-if="!status.active && user.Maintenance >= 1" class="mb-4">
          <label>Wartungsmodus automatisch abschalten um (optional)</label>
          <input type="datetime-local" v-model="until" class="border-2 border-gray-200 px-2 py-1 w-full">
        </div>
        <div v-if="user.Maintenance >= 1">
          <button v-if="status.active" @click="toggle" class="bg-green-500 text-white">Wartungsmodus ausschalten</button>
          <button v-else @click="toggle" class="bg-red-500 text-white">Wartungsmodus einschalten</button>
        </div>
        <div v-if="message" class="mt-4" :class="messageSuccess ? 'text-green-600' : 'text-red-600'">{{ message }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import API from "@/API";
export default {
  name: "Maintenance",
  props: ["user"],
  data() {
    return {
      status: { active: false },
      until: "",
      loading: true,
      message: null,
      messageSuccess: false,
    };
  },
  methods: {
    loadStatus() {
      this.loading = true;
      API.getMaintenanceStatus((r, status) => {
        if (status === 200) {
          this.status = r;
        }
        this.loading = false;
      });
    },
    toggle() {
      this.message = null;
      API.toggleMaintenance({ until: this.until || null }, (r, status) => {
        if (status === 200) {
          this.status.active = r.active;
          this.messageSuccess = true;
          this.message = r.message;
          this.until = "";
        } else {
          this.messageSuccess = false;
          this.message = "Aktion fehlgeschlagen.";
        }
      });
    },
  },
  created() {
    this.loadStatus();
  },
};
</script>

<style scoped>
label { display: block; font-weight: bold; margin-bottom: 4px; }
</style>
